{
  "table": {
    "ranAt": "Exécuté à",
    "type": "Type",
    "numPortfolios": "# de portefeuilles",
    "organization": "Organisation",
    "state": "État",
    "actions": "Actions",
    "run": "Exécuter",
    "bulkV2Unavailable": "L'optimisation en vrac n'est pas encore disponible pour l'Optimiseur V2."
  },
  "filters": {
    "selectOrganization": "Sélectionner l'organisation"
  },
  "portfolioOptimizerType": {
    "DRIFT": "Dérive",
    "TRANSFER": "Virement"
  },
  "portfolioOptimizerState": {
    "CANCELED": "Annulé",
    "COMPLETED": "Terminé",
    "FAILED": "Échoué",
    "INITIATED": "Initié",
    "SOLVING_FOR_PURCHASES": "Résoudre les achats",
    "PURCHASES_SOLVED": "Achats résolus",
    "OPTIMAL_PORTFOLIOS_GENERATED": "Portefeuilles optimaux générés",
    "OPTIMAL_PORTFOLIOS_GENERATING": "Portefeuilles optimaux générant",
    "SOLVING_FOR_REDEMPTIONS": "Résolution des rachats",
    "REDEMPTIONS_SOLVED": "Remboursements résolus",
    "REBALANCING": "Rééquilibrage",
    "REBALANCED": "Rééquilibré",
    "TAX_OPTIMIZING": "Optimisation fiscale",
    "TAX_OPTIMIZED": "Fiscalité optimisée",
    "GENERATING_ALLOCATIONS": "Génération d'allocations"
  },
  "selectOptimizerModal": {
    "title": "Sélectionner le type d'optimiseur et l'étape",
    "subTitle": "Veuillez choisir si vous souhaitez optimiser les portefeuilles en fonction de la dérive ou des liquidités",
    "setType": "Sélectionner le type d'optimiseur",
    "setStep": "Sélectionner l'étape à mettre en pause",
    "TRANSFER": "Optimiseur de trésorerie",
    "DRIFT": "Optimiseur de dérive",
    "COMPLETE_ALL_STEPS": "Compléter toutes les étapes",
    "OPTIMAL_PORTFOLIOS_GENERATED": "Étape 1 - Génération de portefeuilles optimaux",
    "REDEMPTIONS_SOLVED": "Étape 2 - Remboursements résolus",
    "PURCHASES_SOLVED": "Étape 3 - Achats résolus",
    "REBALANCED": "Étape 4 - Rééquilibrage",
    "TAX_OPTIMIZED": "Étape 5 - Optimisation fiscale"
  },
  "detail": {
    "summaryResults": "Résumé des résultats",
    "proceedToBulkTrader": "Passer au négociant en vrac",
    "portfolioOptimizerState": "L'Optimiseur de portefeuille est dans l'état {{state}}",
    "portfolioOptimizerNewState": "L'Optimiseur de portefeuille est dans l'état {{state}}",
    "cancel": "Annuler"
  },
  "stats": {
    "buys": "Achats",
    "sells": "Ventes",
    "portfoliosAdjusted": "Portefeuilles ajustés",
    "shares": "Actions",
    "amount": "Montant"
  },
  "transitions": {
    "cancel": "Annuler"
  },
  "run": "Exécuter"
}
